import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';

import { GerenciarSaidaCaixaRoutingModule } from './gerenciar-saida-caixa-routing.module';
import { GerenciarSaidaCaixaComponent } from './gerenciar-saida-caixa.component';
import { TableModule } from 'primeng/table';
import { MessagesModule } from 'primeng/messages';
import { ButtonModule } from 'primeng/button';
import { ConfirmDialogModule } from 'primeng/confirmdialog';
import { DialogModule } from 'primeng/dialog';
import { ConfirmationService } from 'primeng/api';
import { InputTextModule } from 'primeng/inputtext';
import { DropdownModule } from 'primeng/dropdown';
import { FormsModule } from "@angular/forms";
import { TooltipModule } from 'primeng/tooltip';


@NgModule({
  declarations: [
    GerenciarSaidaCaixaComponent
  ],
  imports: [
    CommonModule,
    GerenciarSaidaCaixaRoutingModule,
    FormsModule,
    TableModule,
    MessagesModule,
    InputTextModule,
    ButtonModule,
    DialogModule,
    ConfirmDialogModule,
    DropdownModule,
    FormsModule,
    TooltipModule
],
  providers: [ConfirmationService]
})
export class GerenciarSaidaCaixaModule { }
